import React, { useEffect } from "react"

import { Helmet } from "react-helmet"
// Focus visible polyfill so it's present on every page!
import "focus-visible/dist/focus-visible"

import { metaData } from "@data"
import { logTool } from "@jsUtils"

const log = logTool()

/**
 * Meta - Sets HTML <head>, <title>, and OG properties, etc. using Helmet
 * @param {object} props - react props object
 * @param {string} props.title - Meta page title
 * @param {string} props.description - Meta page description
 * @param {string} props.imageObj - image object (see below)
 */
const Meta = props => {
  const { title, description, imageObj, keywords, schemaMarkup = null, hubSpotObj = null } = props
  // Title, Description, and the preview image will default to the values in metaData.js if undefined
  // IMPORTANT: imageObj should be formatted as: {src: "image/src/here.png", width: 666, height: 666}

  const shareTitle = title || metaData.defaultTitle
  const shareDescription = description || metaData.defaultDescription
  const shareKeywords = keywords || metaData.defaultKeywords
  const shareImage = imageObj || metaData.defaultPreviewImage

  useEffect(() => {
    if (typeof window !== "undefined" && hubSpotObj !== null) {
      /* eslint-disable-next-line */
      const _hsq = (window._hsq = window._hsq || [])
      // Hubspot track specific activities completed by visitiors in your website
      _hsq.push([
        "trackCustomBehavioralEvent",
        {
          name: hubSpotObj.contentTypeKey,
          properties: {
            label: hubSpotObj.contentTypeKey,
            url: window.location.href
          }
        }
      ])
      // Hubspot content type
      _hsq.push(["setContentType", hubSpotObj.contentTypeValue])
    }
  }, [shareTitle, hubSpotObj])

  return (
    <Helmet>
      <html lang="en" />
      <title>{shareTitle}</title>

      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={shareDescription} />
      <meta name="keywords" content={shareKeywords} />

      <meta property="og:image" content={`https:${shareImage.src}`} />
      <meta property="og:image:width" content={shareImage.width} />
      <meta property="og:image:height" content={shareImage.height} />
      <meta property="og:title" content={shareTitle} />
      <meta property="og:description" content={shareDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={metaData.twitter} />
      <meta name="twitter:title" content={shareTitle} />
      <meta name="twitter:description" content={shareDescription} />
      <meta name="twitter:image" content={`https:${shareImage.src}`} />
      <meta name="facebook-domain-verification" content="crcc1w6m8pzupntevpwb2092a1v7x4" />
      <meta name="icon" href="/static/favicon.ico" />
      {schemaMarkup !== null && (
        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
      )}
    </Helmet>
  )
}

// Assign & Export
export default Meta

Meta.defaultProps = {
  title: metaData.defaultTitle,
  description: metaData.defaultDescription,
  imageObject: metaData.defaultPreviewImage
}
